// CSS to hide PrimeReact sort icons
export const hideSortIconsStyle = `
  .p-sortable-column-icon {
    display: none !important;
  }
  .p-sortable-column-icon.p-sortable-column-icon-active {
    display: none !important;
  }
  .p-sortable-column-icon.p-sortable-column-icon-up {
    display: none !important;
  }
  .p-sortable-column-icon.p-sortable-column-icon-down {
    display: none !important;
  }
`;

// Component to inject the CSS
export const HideSortIcons = () => {
  return <style>{hideSortIconsStyle}</style>;
};
